import { useState } from "react";
import { SelectFinancialYears } from "components/ui/selectors";
import { useChangeFinancialyear } from "http-hooks/financialyear.js/useFinancialyear";
import useFinancialYearStore from "store/financialYear";
import useAuth from "hooks/useAuth";

export default function SetFinancialYear({ onClose }) {
  // Get current financial year from store
  const { currentFinancialYear, setCurrentFinancialYear } = useFinancialYearStore();
  
  // Get auth hook functions
  const { setToken } = useAuth();
  
  // Keep state as null initially, let SelectFinancialYears handle the initial value
  const [selectedFinancialYear, setSelectedFinancialYear] = useState(null);

  const { mutateAsync: mutateChange, isLoading: isChanging } = useChangeFinancialyear();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!selectedFinancialYear?.srno) {
      return;
    }
    
    try {
      const data = await mutateChange(selectedFinancialYear.srno);
      setToken(data.token);
      setCurrentFinancialYear(data.financial_year);
      onClose();
      window.location.reload();
    } catch (error) {
      console.error("Failed to change financial year:", error);
    }
  };

  const isFormValid = selectedFinancialYear?.srno;

  return (
    <form onSubmit={handleSubmit}>
      <div className="space-y-2">
        <h2 className="text-base font-semibold leading-7 text-gray-900">
          Change Financial Year
        </h2>
        <p className="mt-1 text-sm leading-6 text-gray-600">
          Select your preferred financial year below
        </p>

        <div className="space-y-4">
          <div className="mb-48">
            <SelectFinancialYears
              value={selectedFinancialYear}
              onChange={setSelectedFinancialYear}
              label="New Financial Year"
              placeholder="Select financial year..."
              isRequired={true}
              filters={{ ag_status: "1" }} // Only show active financial years
              maxMenuHeight={200}
              initialValue={{ srno: currentFinancialYear.fy_id }} // Pass current financial year as initial value
            />
          </div>
        </div>
      </div>

      <div className="mt-6 flex items-center justify-end gap-x-6">
        <button
          type="button"
          className="text-sm font-semibold leading-6 text-gray-900 hover:text-gray-700"
          onClick={onClose}
          disabled={isChanging}
        >
          Cancel
        </button>
        <button
          type="submit"
          disabled={!isFormValid || isChanging}
          className="rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 disabled:opacity-50 disabled:cursor-not-allowed"
        >
          {isChanging ? "Changing..." : "Change Financial Year"}
        </button>
      </div>
    </form>
  );
} 